import React, { useState, useContext, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { FilterContext } from "../../../../contexts/Filters/FiltersContext";
import { DashboardContext } from "../../../../contexts/Dashboard/DashboardContext";
import Select, { MultiValue } from "react-select";
import { IoFunnelOutline, IoFunnel } from "react-icons/io5";

interface Filter {
  value: string;
  label: string;
}

const FilterMain = () => {
  const { completeRequisition, couriers, regions, shippers, routeTypes } =
    useContext(FilterContext);
  const { filters, saveFilters } = useContext(DashboardContext);
  const [couriersSelected, setCouriersSelected] = useState<Filter[]>([]);
  const [regionsSelected, setRegionsSelected] = useState<Filter[]>([]);
  const [shippersSelected, setShippersSelected] = useState<Filter[]>([]);
  const [clientsSelected, setClientsSelected] = useState<string[]>([]);
  const [clientsInput, setClientsInput] = useState<string>("");
  const [routeTypesSelected, setRouteTypesSelected] = useState<Filter[]>([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (completeRequisition) {
      if (filters) {
        if (
          filters.couriers &&
          filters.couriers.length > 0 &&
          couriers &&
          couriers.length > 0
        ) {
          couriers.map((courier: Filter) => {
            if (filters.couriers.includes(courier.value)) {
              couriersSelected.push(courier);
            }
          });
          setCouriersSelected(couriersSelected);
        }
        if (
          filters.shippers &&
          filters.shippers.length > 0 &&
          shippers &&
          shippers.length > 0
        ) {
          shippers.map((shipper: Filter) => {
            if (filters.shippers.includes(shipper.value)) {
              shippersSelected.push(shipper);
            }
          });
          setShippersSelected(shippersSelected);
        }
        if (
          filters.regions &&
          filters.regions.length > 0 &&
          regions &&
          regions.length > 0
        ) {
          regions.map((region: Filter) => {
            if (filters.regions.includes(region.value?.toString())) {
              regionsSelected.push(region);
            }
          });
          setRegionsSelected(regionsSelected);
        }
        if (filters.clients && filters.clients.length > 0) {
          setClientsInput(filters.clients.join(";"));
        }
        if (
          filters.routeTypes &&
          filters.routeTypes.length > 0 &&
          routeTypes &&
          routeTypes.length > 0
        ) {
          routeTypes.map((routeType: Filter) => {
            if (filters.routeTypes.includes(routeType.value?.toString())) {
              routeTypesSelected.push(routeType);
            }
          });
          setRouteTypesSelected(routeTypesSelected);
        }
      }
    }
  }, [completeRequisition]);

  useEffect(() => {
    if (clientsInput.endsWith(";")) handleChangeMultipleClients(clientsInput);
    else handleChangeMultipleClients(clientsInput + ";");
  }, [clientsInput]);

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    saveFilters({
      couriers: couriersSelected.map((courier: Filter) => courier.value),
      regions: regionsSelected.map((region: Filter) => region.value),
      shippers: shippersSelected.map((shipper: Filter) => shipper.value),
      clients: clientsSelected.map((client: string) => client),
      routeTypes: routeTypesSelected.map(
        (routeType: Filter) => routeType.value
      ),
    });
  };

  const handleChangeMultipleCouriers = (couriersEvent: MultiValue<Filter>) => {
    const couriersSelectedd: Filter[] = [];
    couriersEvent.forEach((carrier: Filter) => {
      couriersSelectedd.push({ label: carrier.label, value: carrier.value });
    });

    setCouriersSelected(couriersSelectedd);
  };

  const handleChangeMultipleRegions = (regionsEvent: MultiValue<Filter>) => {
    const regionsSelectedd: Filter[] = [];
    regionsEvent.forEach((region: Filter) => {
      regionsSelectedd.push({ label: region.label, value: region.value });
    });

    setRegionsSelected(regionsSelectedd);
  };

  const handleChangeMultipleShippers = (shippersEvent: MultiValue<Filter>) => {
    const shippersSelectedd: Filter[] = [];
    shippersEvent.forEach((shipper: Filter) => {
      shippersSelectedd.push({ label: shipper.label, value: shipper.value });
    });

    setShippersSelected(shippersSelectedd);
  };

  const handleChangeMultipleClients = (clientsEvent: string) => {
    const clientsSelectedd: string[] = clientsEvent.split(";");
    if (clientsSelectedd[0] !== "")
      setClientsSelected(
        clientsSelectedd.splice(0, clientsSelectedd.length - 1)
      );
    else setClientsSelected([]);
  };

  const handleChangeMultipleRouteTypes = (
    routeTypesEvent: MultiValue<Filter>
  ) => {
    const routeTypesSelectedd: Filter[] = [];
    routeTypesEvent.forEach((routeType: Filter) => {
      routeTypesSelectedd.push({
        label: routeType.label,
        value: routeType.value,
      });
    });

    setRouteTypesSelected(routeTypesSelectedd);
  };

  return completeRequisition ? (
    <>
      <Button
        type="button"
        className={
          "button-filter " +
          (shippersSelected.length > 0 ||
          regionsSelected.length > 0 ||
          couriersSelected.length > 0 ||
          clientsSelected.length > 0 ||
          routeTypesSelected.length > 0
            ? "button-with-filter"
            : "button-no-filter")
        }
        onClick={handleShow}
      >
        <div className="display-flex">
          {shippersSelected.length > 0 ||
          regionsSelected.length > 0 ||
          couriersSelected.length > 0 ||
          clientsSelected.length > 0 ||
          routeTypesSelected.length > 0 ? (
            <IoFunnel />
          ) : (
            <IoFunnelOutline />
          )}
          <div className="mx-2">Filtros</div>
        </div>
      </Button>

      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">Filtros</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {shippers.length !== 1 ? (
            <div>
              <label>Embarcador</label>
              <Select
                isMulti
                className="div-select"
                defaultValue={shippersSelected}
                options={shippers}
                placeholder="Selecione o embarcador"
                onChange={handleChangeMultipleShippers}
              />
            </div>
          ) : (
            <></>
          )}
          {regions.length !== 1  ? (
            <div>
              <label>Região</label>
              <Select
                isMulti
                className="div-select"
                defaultValue={regionsSelected}
                options={regions}
                placeholder="Selecione a região"
                onChange={handleChangeMultipleRegions}
              />
            </div>
          ) : (
            <></>
          )}
          {couriers.length !== 1 ? (
            <div>
              <label>Transportadora</label>
              <Select
                isMulti
                className="div-select"
                defaultValue={couriersSelected}
                options={couriers}
                placeholder="Selecione a transportadora"
                onChange={handleChangeMultipleCouriers}
              />
            </div>
          ) : (
            <></>
          )}
          <div>
            <label>
              Cliente (para buscar multiplos clientes separe-os com " ; ")
            </label>
            <input
              className="filter-input-text"
              type="text"
              placeholder="Digite o cliente"
              value={clientsInput}
              onChange={(e) => setClientsInput(e.target.value)}
            />
          </div>
          {routeTypes.length !== 1 ? (
            <div>
              <label>Tipo de Rota</label>
              <Select
                isMulti
                className="div-select"
                defaultValue={routeTypesSelected}
                options={routeTypes}
                placeholder="Selecione o tipo de rota"
                onChange={handleChangeMultipleRouteTypes}
              />
            </div>
          ) : (
            <></>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" variant="primary" onClick={handleClose}>
            Sair
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  ) : (
    <></>
  );
};

export default FilterMain;
